import Axios from 'axios';

export const ApiService = Axios.create({
    baseURL: `${link_url}`,
});

ApiService.interceptors.response.use(
    function(response) {
        // Do something with response data

        return response;
    },
    function(error) {
        if (
            (error.response && error.response.status === 503) ||
            (error.response && error.response.status === 419)
        ) {
            location.reload();
        }

        // Do something with response error
        return Promise.reject(error);
    }
);
